import {
  activeSpaceReducer,
  appReducer,
  authReducer,
  calendarReducer,
  clusterModuleReducer,
  currentModuleReducer,
  deviceModuleReducer,
  kbarReducer,
  notificationsReducer,
  pageTitleReducer,
  uiReducer,
} from './toolkits';

export const reducer = {
  notifications: notificationsReducer,
  kbar: kbarReducer,
  pageTitle: pageTitleReducer,
  ui: uiReducer,
  activeSpace: activeSpaceReducer,
  auth: authReducer,
  app: appReducer,
  currentModule: currentModuleReducer,
  devices: deviceModuleReducer,
  calendar: calendarReducer,
  cluster: clusterModuleReducer,
};
